"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBrowserOnlyValues = useBrowserOnlyValues;
const react_1 = require("react");
function useBrowserOnlyValues(createValues) {
    const [values, setValues] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        setValues(createValues());
    }, []);
    return values;
}
